/* eslint-disable react-native/no-inline-styles */

import React from 'react';
import { ScrollView, StyleSheet, TouchableOpacity, View } from 'react-native';
import PropTypes from 'prop-types';

import ModalFull from '@components/modal/ModalFull';
import SociollaText from '@components/sociolla/SociollaText';
import Image from '@components/global/Image';
import ItemDetail from '@components/global/ItemDetail';
import RenderIf from '@components/global/RenderIf';
import TitleSubSection from '@components/global/TitleSubSection';
import Button from '@components/form/Button';

import { isWeb, fullHeight, isMobileWeb } from '@global/screens';
import { downloadFile } from '@global/helpers';
import Colors from '@global/colors';

const propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  data: PropTypes.object,
  handleEditModal: PropTypes.func,
  handleDetail: PropTypes.func,
  hasAccessCreate: PropTypes.bool,
};

const ModalAttachment = (props) => {
  const data = props?.data;
  const attachments = data?.attachments || [];

  const handleShowAttachment = (attachment) => {
    downloadFile(attachment.url, attachment.name, '', true, false);
  };

  const handleEdit = () => {
    props.onClose();
    props.handleEditModal(data);
  };

  const handleSeeDetails = () => {
    props.onClose();
    props.handleDetail(data);
  };

  return (
    <ModalFull
      show={props.show}
      title={`${isWeb ? 'See Attachments' : data?.year}`}
      width={isWeb ? 650 : '100%'}
      onClose={props.onClose}>
      <View>
        {attachments?.length > 0 ? (
          <ScrollView contentContainerStyle={styles.scrollContainer}>
            <RenderIf condition={!isWeb}>
              <ItemDetail
                name="Periode"
                value={data?.year}
                withoutBorder
                style={{ paddingHorizontal: 20 }}
              />
              <TitleSubSection title={'ATTACHMENTS'} />
            </RenderIf>

            {attachments.map((a, index) => (
              <View key={'list-attachment-' + index} style={styles.list}>
                <SociollaText>Attachment {index + 1}</SociollaText>
                <SociollaText>{a.name}</SociollaText>
                <TouchableOpacity onPress={() => handleShowAttachment(a)}>
                  <Image
                    style={{ width: 24, height: 16 }}
                    source={require('@assets/img/icons/eye.png')}
                    isResolveAsset
                  />
                </TouchableOpacity>
              </View>
            ))}

            <RenderIf condition={!isWeb}>
              <View style={styles.btnContainer}>
                <RenderIf condition={props.hasAccessCreate}>
                  <View style={styles.buttonWrapper}>
                    <Button
                      type="default"
                      rounded={true}
                      buttonStyle={styles.button}
                      title={
                        <SociollaText type="medium" style={{ fontSize: 14 }}>
                          Edit
                        </SociollaText>
                      }
                      onPress={handleEdit}
                    />
                  </View>
                </RenderIf>
                <View style={styles.buttonWrapper}>
                  <Button
                    type="primary"
                    rounded={true}
                    buttonStyle={styles.button}
                    title={
                      <SociollaText
                        type="medium"
                        style={{ fontSize: 14, color: Colors.white }}>
                        See Details
                      </SociollaText>
                    }
                    onPress={handleSeeDetails}
                  />
                </View>
              </View>
            </RenderIf>
          </ScrollView>
        ) : (
          <>
            <SociollaText style={{ textAlign: 'center', paddingVertical: 40 }}>
              No attachment found.
            </SociollaText>
            <View style={{ paddingHorizontal: 10, marginTop: 'auto' }}>
              <Button
                type="default"
                rounded={true}
                buttonStyle={styles.button}
                title={
                  <SociollaText type="medium" style={{ fontSize: 14 }}>
                    Edit
                  </SociollaText>
                }
                onPress={handleEdit}
              />
            </View>
          </>
        )}
      </View>
    </ModalFull>
  );
};

const styles = StyleSheet.create({
  scrollContainer: {
    paddingBottom: 20,
    maxHeight: isWeb ? 400 : isMobileWeb ? fullHeight - 160 : 'none',
  },
  list: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    marginVertical: 10,
  },
  btnContainer: {
    flexDirection: 'row',
    marginTop: 20,
    alignItems: 'center',
    gap: 10,
    paddingHorizontal: 10,
  },
  buttonWrapper: {
    flex: 1,
  },
  button: {
    width: '100%',
  },
});

ModalAttachment.propTypes = propTypes;

export default ModalAttachment;
